import { render, staticRenderFns } from "./MonitorProcessoDetalhes.vue?vue&type=template&id=6138c36e"
import script from "./MonitorProcessoDetalhes.vue?vue&type=script&lang=js"
export * from "./MonitorProcessoDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports